import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { ArticleEnums } from 'src/app/enum/article-enums';
import { OptionWindow } from 'src/app/enum/option-window-enums';
import { ProfileUserEnums } from 'src/app/enum/profile-user-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleTableModel } from 'src/app/models/tables/archive/article-table.model';
import { EquipmentLogbookTableModel } from 'src/app/models/tables/archive/equipment-logbook-table.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { EquipmentLogbookService } from 'src/app/services/archive/equipment-logbook.service';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { ImportArticleComponent } from '../import-article/import-article.component';
import { ImportEquipmentLogbookComponent } from '../import-equipment-logbook/import-equipment-logbook.component';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss'],
  standalone: false
})
export class ArticleComponent implements OnInit {

  @ViewChild('articleImportModal') articleImportModalComponent?: CustomModalComponent | null = null;
  @ViewChild('equipmentLogbookImportModal') equipmentLogbookImportModalComponent?: CustomModalComponent | null = null;
  activeTabIndex = 0;
  articleData: PagedResponseModel<ArticleTableModel> = new PagedResponseModel<ArticleTableModel>();
  articleHeader: ColumnResponseModel[] = [];
  ascendant: boolean = true;
  componentArticleImportModal = ImportArticleComponent;
  componentEquipmentLogbookImportModal = ImportEquipmentLogbookComponent;
  columnSort: string | null = null;
  filters: ColumnResponseModel[] = [];
  isOpened: string | undefined = undefined;
  inputsForArticleModals$ = new BehaviorSubject<any>({
    swGeneric: 0,
  });
  limit: number = 10;
  nameWindow: string = 'Artículos';
  page: number = 1;
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  previousSort: { field: string; isAscsendant: number };
  equipmentLogbookData: PagedResponseModel<EquipmentLogbookTableModel> = new PagedResponseModel<EquipmentLogbookTableModel>();
  equipmentLogbookHeader: ColumnResponseModel[] = [];
  storeConsolidated: boolean = true;
  swGeneric: number = ArticleEnums.article;
  swMaintenanceOrder: boolean = false;
  tableActions: TableAction[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      action: 'edit'
    }, {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      action: 'delete'
    },
  ];
  tableActionsHV: TableAction[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      action: 'edit'
    },
  ];
  url: string = "article";
  userAuthenticated: UserModel = new UserModel();

  constructor(private articleService: ArticleService,
    private confirmDialogService: ConfirmDialogService,
    private equipmentLogbookService: EquipmentLogbookService,
    private headerService: HeaderService,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) { }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    const filters = localStorage.getItem(this.url);
    if (filters) this.filters = JSON.parse(filters);
    this.getPermission();
    await Promise.all([
      this.getColumnsForGeneralConsultationArticle(),
      this.getAllArticlesWithPagination(),
    ]);
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async deleteArticle(article: ArticleTableModel) {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para eliminar artículos. Comuníquese con el administrador del sistema.`
      );
      return;
    }

    if (await this.confirmDialogService.confirm('¿Realmente desea eliminar el artículo?')) {
      try {
        await firstValueFrom(this.articleService.deleteArticle(article.articleId));
        await this.getAllArticlesWithPagination();
        this.toastHandlerService.showToast(
          'success',
          `El artículo fue eliminado exitosamente.`
        );
      } catch (error) {
        console.error('Error al eliminar el artículo.', error);
      }
    }
  }

  async exportGeneralConsultationArticle() {
    try {
      const response = await firstValueFrom(
        this.articleService.exportGeneralConsultation(this.filters, this.columnSort, this.ascendant)
      );
      const blob = response;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Articulos.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al exportar los articulos.', error);
    }
  }

  async exportGeneralConsultationEquipmentLogbook() {
    try {
      const response = await firstValueFrom(
        this.equipmentLogbookService.exportGeneralConsultation(this.filters, this.columnSort, this.ascendant)
      );
      const blob = response;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'HojasdeVidaArticulos.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al exportar las hojas de vida de los articulos.', error);
    }
  }

  async getAllArticlesWithPagination() {
    try {
      this.articleData = await firstValueFrom(
        this.articleService.getAllArticlesWithPagination(
          this.page, this.limit, this.columnSort, this.ascendant, this.filters
        )
      );
    } catch (error) {
      console.error('Error al buscar los artículos.', error);
    }
  }

  async getAllEquipmentLogbooksWithPagination() {
    try {
      this.equipmentLogbookData = await firstValueFrom(
        this.equipmentLogbookService.getAllEquipmentLogbooksWithPagination(
          this.page, this.limit, this.columnSort, this.ascendant, this.filters
        )
      );
    } catch (error) {
      console.error('Error al buscar las hojas de vida de los articulos.', error);
    }
  }

  async getColumnsForGeneralConsultationArticle() {
    try {
      if (this.articleHeader.length === 0) {
        this.articleHeader = await firstValueFrom(this.articleService.getColumnsForGeneralConsultation());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general de articulos.', error);
    }
  }

  async getColumnsForGeneralConsultationEquipmentLogbook() {
    try {
      if (this.equipmentLogbookHeader.length === 0) {
        this.equipmentLogbookHeader = await firstValueFrom(this.equipmentLogbookService.getColumnsForGeneralConsultation());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general.', error);
    }
  }

  getGeneralParametersByCompany() {
    return new Promise((resolve) => {
      this.userAuthenticatedService.generalParameterObservable.subscribe(response => {
        this.swMaintenanceOrder = response.some(x => x.name === "OrdenesDeMantenimiento");
      });
      resolve(true);
    });
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    await Promise.all([
      this.getPermissionProfileByUrl(),
      this.getPermissionsForUserByWindow(),
    ]);
    this.getUserAuthenticated();
    this.getGeneralParametersByCompany();
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al obtener los permisos de la ventana.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    try {
      this.permissionsUser = await firstValueFrom(
        this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.Article)
      );
    } catch (error) {
      console.error('Error al cargar los permisos del usuario.', error);
    }
  }

  async getUserAuthenticated() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0))
    );
  }

  public async handleTabChange(tabIndex: number) {
    this.articleHeader.length = this.articleHeader.length === 1 ? 0 : this.articleHeader.length;
    this.equipmentLogbookHeader.length = this.equipmentLogbookHeader.length === 1 ? 0 : this.equipmentLogbookHeader.length;

    if (this.activeTabIndex === tabIndex) return;

    this.page = 1;
    this.limit = 10;
    this.activeTabIndex = tabIndex;

    switch (this.activeTabIndex) {
      case 0:
        await Promise.all([
          this.getColumnsForGeneralConsultationArticle(),
          this.getAllArticlesWithPagination()
        ]);
        this.articleData = {
          ...this.articleData,
          currentPage: 1,
          pageSize: 10
        };
        break;
      case 1:
        await Promise.all([
          this.getColumnsForGeneralConsultationEquipmentLogbook(),
          this.getAllEquipmentLogbooksWithPagination()
        ]);
        this.equipmentLogbookData = {
          ...this.equipmentLogbookData,
          currentPage: 1,
          pageSize: 10
        };
        break;
    }
  }

  newRegister() {
    this.router.navigate([`/${this.url}/register`]);
  }

  async onAction(event: { action: string, item?: ArticleTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit' && event.item) {
      this.router.navigate([`/${this.url}/register/${event.item.id}`]);
    }
    if (event.action === 'delete' && event.item) {
      await this.deleteArticle(event.item);
    }
  }

  async onExport() {
    switch (this.activeTabIndex) {
      case 0:
        await this.exportGeneralConsultationArticle();
        break;
      case 1:
        await this.exportGeneralConsultationEquipmentLogbook();
        break;
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);

    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  async onImport() {
    if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador ||
      this.permissionsUser.find(x => x.code == OptionWindow.Importar)) {
      if (this.permissionUpdatable) {
        switch (this.activeTabIndex) {
          case 0:
            this.inputsForArticleModals$.next({ swGeneric: this.swGeneric });
            this.articleImportModalComponent?.show();
            break;
          case 1:
            this.equipmentLogbookImportModalComponent?.show();
            break;
        }
      } else {
        this.toastHandlerService.showToast(
          'warning',
          `El usuario no tiene permisos para la edición de artículos. Comuníquese con el administrador del sistema.`
        );
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para importar artículos, comuniquese con el administrador del sistema.`
      );
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    switch (this.activeTabIndex) {
      case 0:
        await this.getAllArticlesWithPagination()
        break;
      case 1:
        await this.getAllEquipmentLogbooksWithPagination()
        break;
    }
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  async reloadList(reload: boolean) {
    if (reload) {
      switch (this.activeTabIndex) {
        case 0: {
          await this.getAllArticlesWithPagination()
          break;
        }
        case 1: {
          await this.getAllEquipmentLogbooksWithPagination()
          break;
        }
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }
}
